import {SportstypeSpec} from "../types";
import start from "../../icons/darts/start";
import end from "../../icons/darts/end";
import leg from "../../icons/darts/leg";
import main from "../../icons/darts/main";

const darts: SportstypeSpec = {
  id: 'darts',
  svg: main,
  releaseStage: 'alpha',
  phases: ['pregame', 'set', 'leg', 'postgame'],
  events: [
    {
      id: 'start',
      important: true,
      svg: start
    },
    {
      id: 'end',
      important: true,
      svg: end
    },
    {
      id: 'leg',
      important: true,
      svg: leg
    }
  ]
}

export default darts;
